import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'

import { fetchConfiguration } from '../../../api/configuration'

import Page from '../../../components/Page'
import ConfigurationForm from '../../../components/forms/ConfigurationForm/ConfigurationForm'
import ConfigurationFormSkeleton from '../../../components/forms/ConfigurationForm/ConfigurationFormSkeleton'

const ConfigurationView = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { data: configuration, isFetching } = useQuery(
    [`configuration-${id}`],
    async () => await fetchConfiguration(id),
  )

  if (isFetching) {
    return <ConfigurationFormSkeleton />
  }

  return (
    <Page pageTitle={t('configuration.view.title')}>
      {configuration && <ConfigurationForm defaultValues={configuration} />}
    </Page>
  )
}

export default ConfigurationView
